if (!customElements.get('before-after-slider')) {
  customElements.define(
    'before-after-slider',
    class BeforeAfterSlider extends HTMLElement {
      connectedCallback() {
        this.handle = this.querySelector('[data-slider-handle]');
        this.afterWrap = this.querySelector('[data-after-wrap]');
        this.grip   = this.querySelector('[data-slider-grip]');

        if (!this.handle || !this.afterWrap) return;

        this.dragging = false;

        this.onPointerDown  = this.onPointerDown.bind(this);
        this.onPointerMove  = this.onPointerMove.bind(this);
        this.onPointerUp    = this.onPointerUp.bind(this);
        this.onKeyDown      = this.onKeyDown.bind(this);
        this.positionGrip   = this.positionGrip.bind(this);

        this.addEventListener('pointerdown', this.onPointerDown);
        this.handle.addEventListener('keydown', this.onKeyDown);
        window.addEventListener('resize', this.positionGrip);

        const initial = parseFloat(this.getAttribute('initial-position'));
        this.setPosition(isNaN(initial) ? 50 : initial);

        // Wait one frame so aspect-ratio has been fully resolved before
        // reading the rendered height for the grip's vertical position.
        requestAnimationFrame(() => this.positionGrip());
      }

      disconnectedCallback() {
        window.removeEventListener('pointermove', this.onPointerMove);
        window.removeEventListener('pointerup',   this.onPointerUp);
        window.removeEventListener('resize',      this.positionGrip);
      }

      // Sets the grip's top in pixels from the slider's actual rendered height
      // so it is always exactly in the vertical centre regardless of
      // how the browser resolves aspect-ratio percentages.
      positionGrip() {
        if (!this.grip) return;
        const height = this.getBoundingClientRect().height;
        if (height > 0) {
          this.grip.style.top = `${height / 2}px`;
        }
      }

      onPointerDown(event) {
        this.dragging = true;
        this.classList.add('is-dragging');
        window.addEventListener('pointermove', this.onPointerMove);
        window.addEventListener('pointerup',   this.onPointerUp);
        this.updateFromClientX(event.clientX);
        event.preventDefault();
      }

      onPointerMove(event) {
        if (!this.dragging) return;
        this.updateFromClientX(event.clientX);
      }

      onPointerUp() {
        this.dragging = false;
        this.classList.remove('is-dragging');
        window.removeEventListener('pointermove', this.onPointerMove);
        window.removeEventListener('pointerup',   this.onPointerUp);
      }

      onKeyDown(event) {
        const current = parseFloat(this.grip
          ? this.grip.style.left
          : this.handle.style.left) || 50;
        let next = current;

        if      (event.key === 'ArrowLeft')  next = Math.max(0,   current - 5);
        else if (event.key === 'ArrowRight') next = Math.min(100, current + 5);
        else if (event.key === 'Home')       next = 0;
        else if (event.key === 'End')        next = 100;
        else return;

        event.preventDefault();
        this.setPosition(next);
      }

      updateFromClientX(clientX) {
        const rect = this.getBoundingClientRect();
        if (!rect.width) return;
        const position = ((clientX - rect.left) / rect.width) * 100;
        this.setPosition(Math.min(100, Math.max(0, position)));
      }

      setPosition(position) {
        this.afterWrap.style.clipPath = `inset(0 ${100 - position}% 0 0)`;
        this.handle.style.left = `${position}%`;
        // Move grip horizontally in sync with the handle line
        if (this.grip) this.grip.style.left = `${position}%`;
        this.handle.setAttribute('aria-valuenow', Math.round(position));
      }
    }
  );
}
